import React from "react";
import { Box, Container } from "@mui/material";
import { useMaterialUIController } from "context";

export default function DashboardLayout({ children }) {
  const [controller] = useMaterialUIController();
  const { miniSidenav } = controller;

  return (
    <Box sx={{ display: "flex" }}>
      {/* Sidebar */}
      <Box
        component="nav"
        sx={{
          width: miniSidenav ? 80 : 280,  // <-- Dynamically adjust width
          flexShrink: 0,
          transition: "width 0.3s ease-in-out",  // smooth transition
          overflow: "hidden",  // Optional: hide text/icon overflow
          backgroundColor: "#fff",
        }}
      >
        {/* Place your actual Sidebar component here if needed */}
      </Box>

      {/* Main content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: "100%",
        }}
      >
        <Container maxWidth="xl">{children}</Container>
      </Box>
    </Box>
  );
}

